import { RefObject, useEffect } from 'react';

/**
 * Custom hook to add tooltips to non-Monday dates in the date picker for PILOT customers
 */
export const usePilotDateTooltip = (
  containerRef: RefObject<HTMLElement | null>,
  isPilot: boolean
) => {
  useEffect(() => {
    if (!isPilot) return;

    const handleMouseOver = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const dayButton = target.closest('.rdp-day') as HTMLElement;

      if (dayButton) {
        // Remove any existing title first
        dayButton.removeAttribute('title');

        // Only add tooltip if it's a disabled non-Monday date
        if (dayButton.getAttribute('aria-disabled') === 'true') {
          const dateStr = dayButton.getAttribute('data-day');
          if (dateStr) {
            const date = new Date(dateStr);
            // Check if it's not Monday (getDay() returns 1 for Monday)
            if (date.getDay() !== 1) {
              dayButton.setAttribute(
                'title',
                'PILOT customers must start on a Monday'
              );
            }
          }
        }
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('mouseover', handleMouseOver);
      return () => container.removeEventListener('mouseover', handleMouseOver);
    }
  }, [isPilot, containerRef]);
};
